<template>
	<div class="c-app flex-row align-items-center">
		<CContainer>
			<CRow class="justify-content-center">
				<CCol md="12">
					<CCardGroup>
						<CCard
							color="primary"
							text-color="white"
							class="text-center d-md-down-none"
							body-wrapper
						>
							<CCardBody>
								<img
									:src="logo"
									style="width: 13rem; height: 3rem"
									class="mb-2"
								/>
								<img src="login1.png" style="width: 24rem; height: 14rem" />

								<h3>Your Prescription for Savings</h3>
							</CCardBody>
						</CCard>
						<CCard class="p-4">
							<CCardBody>
								<CForm>
									<div class="p-4">
										<h1>Login</h1>
										<p class="text-muted">Sign In to your account</p>
										<CInput
											placeholder="Email"
											autocomplete="email"
											prepend="@"
											:value.sync="$v.loginDetails.mail.$model"
											:lazy="false"
											:isValid="checkIfValid('mail')"
											invalidFeedback="Enter a valid email id"
											class="email login-form-group"
											@keyup.enter="handleLogin"
										/>
										<CInput
											placeholder="Password"
											type="password"
											autocomplete="curent-password"
											:value.sync="$v.loginDetails.password.$model"
											:lazy="false"
											:isValid="checkIfValid('password')"
											invalidFeedback="Enter a valid password. Min 8 characters"
											class="login-form-group"
											@keyup.enter="handleLogin"
										>
											<template #prepend-content>
												<CIcon name="cil-lock-locked" />
											</template>
										</CInput>
										<p
											:style="{
												color: 'red',
												textAlign: 'center',
											}"
										>
											{{ loginFeedback }}
										</p>
										<CRow>
											<CCol col="6" class="text-left">
												<CButton
													color="primary"
													@click="handleLogin"
													class="px-4"
													>Login
												</CButton>
											</CCol>
											<CCol col="6" class="text-right">
												<CButton
													color="link"
													class="px-0"
													@click="$router.push('forget-password')"
													>Forgot password?</CButton
												>
												<CButton color="link" class="d-lg-none"
													>Register now!
												</CButton>
											</CCol>
										</CRow>
										<!-- <p class="mt-3 text-muted">
                      Don't have an account?
                      <CLink @click="$router.push('/register')">Sign Up</CLink>
                    </p> -->
									</div>
								</CForm>
							</CCardBody>
						</CCard>
					</CCardGroup>
				</CCol>
			</CRow>
		</CContainer>
		<div class="vld-parent" v-if="isLoading">
			<loading
				:active.sync="isLoading"
				:can-cancel="false"
				:is-full-page="true"
				loader="dots"
			></loading>
		</div>
	</div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email, minLength } from "vuelidate/lib/validators";
import { storeData, assignCategories } from "../../store";
import queries from "./queries";
import logo from "../../assets/images/logo.svg";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import authApi from "../../api/auth";
import gql from "graphql-tag";

const GET_PROJECTS_ALL_CATEGORIES = gql`
	query MyQuery {
		spendmd_db_prime_category_master(order_by: { alias: asc }) {
			id
			alias
			overrided_prime_categories {
				overrided_name
				id
			}
		}
		spendmd_db_category_master(order_by: { alias: asc }) {
			id
			alias
			prime_category
			overrided_secondary_categories {
				overrided_name
				id
			}
		}
		spendmd_db_sub_category_master(order_by: { alias: asc }) {
			id
			alias
			secondary_category
			overrided_sub_categories {
				overrided_name
				id
			}
		}
	}
`;

export default {
	name: "Login",
	components: {
		Loading,
	},
	data() {
		return {
			logo,
			isLoading: false,
			loginDetails: {
				mail: "",
				password: "",
			},
			loginFeedback: "",
		};
	},
	mixins: [validationMixin],
	validations: {
		loginDetails: {
			mail: {
				required,
				email,
			},
			password: {
				required,
				minLength: minLength(8),
			},
		},
	},
	methods: {
		checkIfValid(fieldName) {
			const field = this.$v.loginDetails[fieldName];
			if (!field.$dirty) {
				return null;
			}
			return !(field.$invalid || field.$model === "");
		},

		validate() {
			this.$v.$touch();
		},
		reset() {
			this.loginDetails = {
				mail: "",
				password: "",
			};
			this.approvePendingToasts = [];
			this.invalidUserToasts = [];
		},
		async handleLogin() {
			this.isLoading = true;
			try {
				const res = await authApi.generateAuth({
					email: this.loginDetails.mail,
					password: this.loginDetails.password,
				});
				const result = res?.data;
				if (result.statusCode === 200) {
					storeData.currentUserDetails = result.data.details;
					this.$session.start();
					this.$session.set("accessToken", result.data.accessToken);
					this.$session.set("refreshToken", result.data.refreshToken);
					this.$session.set("role", result.data.details.role.name);
					// await this.getCategories(); //TODO: reactivate this once backend fixes the error
					// await this.getVendors();
					this.$router.push("/summary-dashboard");
				} else {
					this.loginFeedback = result.message;
				}
			} catch (err) {
				this.loginFeedback = "Something went wrong, Please try after sometime";
				console.log(err);
			}
			this.isLoading = false;
		},

		assignCategoryDataToStore(categoryFromDb) {
			let destinationVar = [];
			for (const el of categoryFromDb) {
				// If sys admin
				if (storeData.currentUserDetails.role.name === "sys_admin" || storeData.currentUserDetails.role.name === "group_admin") {
					el.name = el.alias;
				} else {
					if (
						el?.overrided_prime_categories &&
						el?.overrided_prime_categories.length > 0
					) {
						el.name = el.overrided_prime_categories[0].overrided_name;
						el.overridedId = el.overrided_prime_categories[0].id;
					} else if (
						el?.overrided_secondary_categories &&
						el?.overrided_secondary_categories.length > 0
					) {
						el.name = el.overrided_secondary_categories[0].overrided_name;
						el.overridedId = el.overrided_secondary_categories[0].id;
					} else if (
						el?.overrided_sub_categories &&
						el?.overrided_sub_categories.length > 0
					) {
						el.name = el.overrided_sub_categories[0].overrided_name;
						el.overridedId = el.overrided_sub_categories[0].id;
					} else {
						el.name = el.alias;
						el.overrided = false;
					}
				}

				delete el.alias;
				destinationVar.push(el);
			}
			return destinationVar;
		},

		async getCategories() {
			this.$apollo
				.mutate({
					mutation: GET_PROJECTS_ALL_CATEGORIES,
				})
				.then((res) => {
					const result = res.data;
					console.log("result----",result);
					storeData.primeCategories = assignCategories(
						result.spendmd_db_prime_category_master
					);
					storeData.categories = assignCategories(
						result.spendmd_db_category_master
					);
					storeData.subCategories = assignCategories(
						result.spendmd_db_sub_category_master
					);
				})
				.catch((err) => {
					console.log(err);
				});
		},

		// Get Vendors
		async getVendors() {
			this.$apollo
				.mutate({
					mutation: GET_VENDORS,
				})
				.then((res) => {
					storeData.vendorDataList = res?.data?.spendmd_db_vendor_master;

					for (const el of storeData.vendorDataList) {
						if (el.city == null) el.city = "";
						if (el.zip_code == null) el.zip_code = "";
					}

					storeData.vendorCategoryAllocation =
						res?.data?.spendmd_db_vendor_category_allocation;
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
	created() {
		sessionStorage.clear();
	},
};

const GET_VENDORS = gql`
	query myQuery {
		spendmd_db_vendor_master(order_by: { vendor_name: asc }) {
			id
			vendor_name
			client_id
			city
			address
			keywords
			normal_name
			state
			website
			zip_code
		}
	}
`;
</script>

<style scoped>
.login-form-group {
	margin-bottom: 1rem !important;
}
</style>
